<div class="gallery">
	<!--  PLACEHOLDER (NO IMAGES)  -->

	<div *ngIf="images.length < 1" class="gallery-placeholder">
		<div>
			<i class="icon-no-car"></i>
			<p>No images</p>
		</div>
	</div>

	<!--  END PLACEHOLDER (NO IMAGES)  -->

	<!--  SWIPER  -->

	<swiper
		*ngIf="swiper_loaded && images.length > 0"
		[config]="swiper_config"
		#swiper
		(window:resize)="!!swiper && updateSwiper(swiper.swiper)"
	>
		<div class="swiper-wrapper" #gallery>
			<div *ngFor="let image of images; let i = index" class="swiper-slide">
				<img [attr.src]="image" src="//:0" (error)="onImageError(i)" />
			</div>
		</div>
		<div *ngIf="images.length > 1" class="swiper-pagination-arrows">
			<div
				class="swiper-button-next text-hl"
				[tooltip]="'Next'"
				data-element-click="gallery_arrow_next__engage_configure_gallery__[Next]"
			></div>
			<div
				class="swiper-button-prev text-hl"
				[tooltip]="'Previous'"
				data-element-click="gallery_arrow_previous__engage_configure_gallery__[Previous]"
			></div>
		</div>
	</swiper>

	<!--  END SWIPER  -->

	<!--  PAGINATION  -->

	<div *ngIf="show_pagination" class="swiper-pagination"></div>

	<!-- END PAGINATION  -->
</div>
